import React, { useCallback, useEffect, useState } from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import './UserPanel.scss';

export default function UserPanel({ menuMode }) {
  const { user, signOut, refreshSession } = useAuth();
  const [menuItems, setMenuItems] = useState([]);

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      console.log(error);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      let items = []
      items.push({
        text: user.signInUserSession.idToken.payload.email,
        icon: 'fas fa-user',
        disabled: true,
      })
      items.push({
        text: 'Logout',
        icon: 'fas fa-sign-out-alt',
        onClick: signOut
      })
      setMenuItems(items)
    }
  }, [user, setMenuItems, signOut]);

  const dropDownButtonAttributes = {
    class: 'user-button'
  };

  const buttonDropDownOptions = {
    width: 'auto'
  };

  return (
    <div className='user-panel'>
      {menuMode === 'context' && (

        <DropDownButton
            stylingMode='text'
            text={"Account"}
            showArrowIcon={false}
            elementAttr={dropDownButtonAttributes}
            dropDownOptions={buttonDropDownOptions}
            items={menuItems}
        >

        </DropDownButton>

      )}
      {menuMode === 'list' && (
        <List items={menuItems} />
      )}
    </div>
  );
}
